/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 * ResponseApi
 *
 * A utility function to standardize API response handling.
 * Returns the expected data if the response is successful (status code 2xx),
 * otherwise returns an empty array or null based on the `list` flag.
 *
 * @param {object} payload - The response object, typically from an API call.
 * @param {boolean} list - Indicates whether the expected return type is a list/array.
 *                         If true and the response fails, an empty array is returned.
 *                         If false, null is returned on failure.
 *
 * @returns {*} - Returns `data.data` if the response is successful.
 *                Returns `[]` or `null` if the response fails, based on the `list` flag.
 */

export const ResponseApi = (payload, list = false) => {
    const { data, status } = payload || {};

    // Return the response data if the status code indicates success (2xx)
    if (status >= 200 && status < 300) {
        return data?.data;
    }

    // Return an empty array or null depending on the 'list' flag
    return list ? [] : null;
}
